import { DEAL_SWAP_ROLES_ARTICLE_SECTION } from "../constants/dealSwapRoles.constants";

type DealSwapRolesSection = (typeof DEAL_SWAP_ROLES_ARTICLE_SECTION)[number];

export const isDealSwapRolesSection = (
  section: string,
): section is DealSwapRolesSection => {
  return DEAL_SWAP_ROLES_ARTICLE_SECTION.some(
    (roleSection) => roleSection === section,
  );
};
